import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from 'recharts';

// Matches the accent palette defined in super-admin.css
const ROLE_COLORS = ['#1E88E5', '#2E7D32', '#F59E0B', '#D32F2F', '#8E24AA'];

const ROLE_LABELS = {
  customer: 'مشتری',
  vendor: 'فروشنده',
  irancharsouq_admin: 'ادمین ایران‌چار‌سوق',
  super_admin: 'سوپر ادمین',
};

const tooltipStyle = {
  backgroundColor: 'var(--card-bg)',
  borderColor: 'var(--card-border)',
  borderRadius: 'var(--radius-sm)',
  boxShadow: 'var(--shadow-md)',
  color: 'var(--text-primary)',
};

export default function AnalyticsChart({ ordersByStatus = [], usersByRole = [] }) {
  const orderData = ordersByStatus.map((item) => ({
    status: item.status,
    count: item.count,
  }));

  const roleData = usersByRole.map((item) => ({
    name: ROLE_LABELS[item.role_type] ?? item.role_type,
    value: item.count,
  }));

  return (
    <div className="analytics-grid">
      {/* Order Status Bar Chart */}
      <div className="card chart-card">
        <h3>وضعیت سفارشات</h3>
        {orderData.length === 0 ? (
          <div className="chart-empty">داده‌ای برای نمایش وجود ندارد</div>
        ) : (
          <div className="chart-body">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={orderData} margin={{ top: 10, right: 10, left: 10, bottom: 20 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--gray-light)" />
                <XAxis dataKey="status" tick={{ fill: 'var(--text-secondary)', fontSize: 12 }} />
                <YAxis allowDecimals={false} tick={{ fill: 'var(--text-secondary)', fontSize: 12 }} />
                <Tooltip contentStyle={tooltipStyle} />
                <Bar dataKey="count" name="تعداد" fill="var(--green-light)" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      {/* User Roles Pie Chart */}
      <div className="card chart-card">
        <h3>توزیع نقش‌های کاربران</h3>
        {roleData.length === 0 ? (
          <div className="chart-empty">داده‌ای برای نمایش وجود ندارد</div>
        ) : (
          <div className="chart-body">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={roleData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={80}
                  paddingAngle={5}
                  dataKey="value"
                >
                  {roleData.map((_, index) => (
                    <Cell key={`cell-${index}`} fill={ROLE_COLORS[index % ROLE_COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip contentStyle={tooltipStyle} />
                <Legend verticalAlign="bottom" height={36} iconType="circle" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
